module.exports = require("discourse/lib/case-converter");